var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgColorText = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317 568 c-65 -172 -117 -316 -117 -320 0 -5 20 -8 44 -8 38 0 46 4 52 23 4 12 20 57 36 100 l30 77 118 0 118 0 30 -77 c16 -43 32 -88 36 -100 6 -19 14 -23 52 -23 24 0 44 3 44 8 0 4 -52 148 -117 320 l-116 312 -47 0 -47 0 -116 -312z m210 65 l40 -108 -44 -3 c-23 -2 -63 -2 -86 0 l-44 3 40 108 c22 59 43 107 47 107 4 0 25 -48 47 -107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 120 l0 -40 280 0 280 0 0 40 0 40 -280 0 -280 0 0 -40z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColorText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/color-text.fff52aa1.svg";
export { ForwardRef as ReactComponent };